import { render, staticRenderFns } from "./CardStepperResume.vue?vue&type=template&id=6540d3c1"
import script from "./CardStepperResume.js?vue&type=script&lang=js&external"
export * from "./CardStepperResume.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports